class ProductLightbox {
  constructor(root) {
    this.root = root;
    this.dialog = root.querySelector('[data-product-lightbox]');
    this.gallery = root.querySelector('[data-product-gallery]');
    this.items = Array.from(root.querySelectorAll('[data-lightbox-item]'));
    this.image = this.dialog?.querySelector('[data-lightbox-image]');
    this.counter = this.dialog?.querySelector('[data-lightbox-counter]');
    this.closeButton = this.dialog?.querySelector('[data-lightbox-close]');
    this.previousButton = this.dialog?.querySelector('[data-lightbox-previous]');
    this.nextButton = this.dialog?.querySelector('[data-lightbox-next]');
    // Keep this synchronized with the structural desktop query in product.liquid.
    this.desktopQuery = window.matchMedia(
      '(min-width: 1025px), (min-width: 769px) and (orientation: landscape)'
    );
    this.activeIndex = 0;
    this.trigger = null;

    if (!this.dialog || !this.gallery || !this.image || this.items.length === 0) return;

    this.onGalleryClick = this.onGalleryClick.bind(this);
    this.onGalleryKeydown = this.onGalleryKeydown.bind(this);
    this.onDialogClick = this.onDialogClick.bind(this);
    this.onDialogKeydown = this.onDialogKeydown.bind(this);
    this.onDialogClose = this.onDialogClose.bind(this);
    this.onBreakpointChange = this.onBreakpointChange.bind(this);

    this.gallery.addEventListener('click', this.onGalleryClick);
    this.gallery.addEventListener('keydown', this.onGalleryKeydown);
    this.dialog.addEventListener('click', this.onDialogClick);
    this.dialog.addEventListener('keydown', this.onDialogKeydown);
    this.dialog.addEventListener('close', this.onDialogClose);
    this.closeButton.addEventListener('click', () => this.dialog.close());
    this.previousButton?.addEventListener('click', () => this.show(this.activeIndex - 1));
    this.nextButton?.addEventListener('click', () => this.show(this.activeIndex + 1));
    this.desktopQuery.addEventListener('change', this.onBreakpointChange);

    this.onBreakpointChange();
  }

  onBreakpointChange() {
    this.items.forEach((item) => {
      if (this.desktopQuery.matches) {
        item.setAttribute('role', 'button');
        item.setAttribute('tabindex', '0');
        item.setAttribute('aria-label', `Agrandir la photo ${item.dataset.lightboxPosition} sur ${this.items.length}`);
      } else {
        item.removeAttribute('role');
        item.removeAttribute('tabindex');
        item.removeAttribute('aria-label');
      }
    });

    if (!this.desktopQuery.matches && this.dialog.open) this.dialog.close();
  }

  onGalleryClick(event) {
    if (!this.desktopQuery.matches) return;
    const item = event.target.closest('[data-lightbox-item]');
    if (!item) return;
    this.open(item);
  }

  onGalleryKeydown(event) {
    if (!this.desktopQuery.matches || !['Enter', ' '].includes(event.key)) return;
    const item = event.target.closest('[data-lightbox-item]');
    if (!item) return;
    event.preventDefault();
    this.open(item);
  }

  open(item) {
    this.trigger = item;
    this.show(this.items.indexOf(item));
    this.dialog.showModal();
    this.closeButton.focus();
  }

  show(index) {
    this.activeIndex = (index + this.items.length) % this.items.length;
    const item = this.items[this.activeIndex];
    this.image.src = item.dataset.lightboxSrc;
    this.image.alt = item.dataset.lightboxAlt;
    this.image.width = Number(item.dataset.lightboxWidth);
    this.image.height = Number(item.dataset.lightboxHeight);
    if (this.counter) this.counter.textContent = `${this.activeIndex + 1} / ${this.items.length}`;
  }

  onDialogClick(event) {
    if (event.target === this.dialog || event.target.matches('[data-lightbox-stage]')) {
      this.dialog.close();
    }
  }

  onDialogKeydown(event) {
    if (event.key === 'ArrowLeft') this.show(this.activeIndex - 1);
    if (event.key === 'ArrowRight') this.show(this.activeIndex + 1);
  }

  onDialogClose() {
    this.trigger?.focus();
    this.trigger = null;
  }
}

document.querySelectorAll('product-details').forEach((product) => new ProductLightbox(product));
